import React from 'react';
import type { DividendInfoBlockData } from '@app-types/performanceDividend';
import DividendKeyValueTable from './DividendKeyValueTable';

export interface DividendInfoGridProps {
  dividendInfo: DividendInfoBlockData;
  relatedSchedule: DividendInfoBlockData;
  /** Figma node 3132:3261 (desktop) / stacked mobile */
  nodeId?: string;
}

/**
 * Two-column desktop / stacked-mobile row for the dividend info and related
 * schedule cards. Desktop parent: Figma 3132:3261, 626x168, two 305px cols.
 * Mobile: Figma 3158:9231 / 3158:9239, stacked with 24px gap.
 */
const DividendInfoGrid: React.FC<DividendInfoGridProps> = ({
  dividendInfo,
  relatedSchedule,
  nodeId = '3132:3261',
}) => (
  <div className="dividend-summary-row" data-node-id={nodeId}>
    <DividendKeyValueTable data={dividendInfo} />
    <DividendKeyValueTable data={relatedSchedule} />
  </div>
);

export default DividendInfoGrid;
